/** 文本路径 */
import { Vue, Component } from "vue-property-decorator";
import appConfig from "@/public/globalConfig";
import { InternalLimitTableIds, OverseaLimitTableIds, LangKeys } from "@/app/utils/constant";
import { RenderLibraryData, LibraryItem } from "@/app/types";

@Component
export default class GetSymbolLibraryData extends Vue {
    libraryWorkerURL: string = appConfig.libraryWorkerURL;
    userWorkerURL: string = appConfig.userWorkerURL;
    worker: any;

    mouseMoveBack = false;

    containerID = "";

    currentShapeIndex = -1;

    currentHoverIndex = -1;

    get menuList() {
        return this.$store.state.library.menuList;
    }

    getLibraryData(groupName: string, tableId: number) {
        let tableData = this.menuList.find((db) => db.groupName === groupName)?.children?.find((table) => table.id === tableId);
        if (!tableData) return;
        let libraryData = [
            {
                lang: appConfig.language,
                data: {
                    DbName: "General",
                    tableName: tableData.tableName,
                    url: tableData.url,
                    versionObj: {
                        tableID: tableData.id,
                        name: tableData.tableName,
                        version: tableData.version,
                        type: tableData.type,
                        group: "General",
                        mcount: tableData.mcount,
                    },
                },
            },
        ];
        return this.downloadDBs(libraryData).then(() => {
            return this.getTableData(groupName, tableData);
        });
    }

    drawImg(img, x, y) {
        let parent = document.getElementById(this.containerID);
        let preview = img.cloneNode(true);
        preview.id = "previewIMG";
        preview.style.cssText = `position:absolute;left:${x}px;top:${y}px;max-width: 64px;max-height: 64px;object-fit:contain;pointer-events:none`;
        parent.appendChild(preview);
    }
    removeImg() {
        let parent = document.getElementById(this.containerID);
        let child = document.getElementById("previewIMG");
        if (child) {
            parent.removeChild(child);
        }
    }

    dbClickImg(e, shape, name, langName, tableID, table_index, preview = false, drawAll = false) {
        // 双击
        if (!shape || this.mouseMoveBack) {
            this.mouseMoveBack = false;
            return;
        }
        if (!preview) {
            this.currentShapeIndex = table_index;
        }
        const isLimitShape = !this.vip && ~this.limitTableIds.indexOf(tableID);
        window["_view"]._tool.endEdit();
        window["_view"].libDbClickAddShape(shape, name, langName, tableID, isLimitShape, drawAll);
    }

    get focusModeExpandLeft() {
        return this.$store.getters.expandLeft;
    }

    get sceneLeft() {
        if (!this.focusModeExpandLeft) return 0;
        return this.$store.state.ui.sceneLeft;
    }
    set sceneLeft(v) {
        this.$store.commit("setStatus", {
            type: "sceneLeft",
            data: v,
        });
    }
    get focusModeExpandTop() {
        return this.$store.getters.expandTop;
    }
    get sceneTop() {
        if (!this.focusModeExpandTop) return 0;
        return this.$store.state.ui.sceneTop;
    }

    selectImg(e, shape, name, langName, index, tableID, tableName, table_index) {
        console.log("selectImg");
        // 左侧边栏使用
        if (e.button == 2 || !shape) {
            return;
        } // 右键返回
        window["_view"]._tool.endEdit();
        let target = e.target;
        let x = e.pageX;
        let y = e.pageY;
        this.drawImg(target, x - 80, y - 32);
        let a = document.getElementById("previewIMG");
        a.style.display = "none";
        a.style.pointerEvents = "none";
        let changeShapeFlag = false;
        let dropX, dropY;

        this.currentShapeIndex = table_index;
        document.onmousemove = (ev) => {
            if (ev.pageX - e.pageX == 0 || ev.pageY - e.pageY == 0) return;
            a.style.display = "block";
            a.style.opacity = "0.5";
            let movex = ev.pageX - x;
            let movey = ev.pageY - y - this.sceneTop;
            if (x + movex > this.sceneLeft) {
                let obj = {
                    x: x + movex - this.sceneLeft,
                    y: y + movey,
                };
                if (!changeShapeFlag) {
                    // 移出的时候，一次性删除原预览图
                    this.removeImg();
                    changeShapeFlag = true;
                    window["_view"].dragEnter([
                        {
                            dragID: tableID,
                            name,
                            langName,
                            obj,
                            shape: shape,
                        },
                    ]);
                }
                window["_view"].dragMove(ev);
            } else {
                if (changeShapeFlag) {
                    // 移回的时候，恢复原预览图
                    window["_view"].dragLeave();
                    this.drawImg(target, x, y);
                    a = document.getElementById("previewIMG");
                    changeShapeFlag = false;
                    this.mouseMoveBack = true;
                }
                a.style.left = x + movex - 80 + "px";
                a.style.top = y + movey - 32 + "px";
            }
            dropX = x + movex;
            dropY = y + movey;
        };
        document.onmouseup = (ev) => {
            let obj = {
                x: dropX,
                y: dropY,
            };

            this.$track("library", "use symbol", "drag" + `tableID:${tableID},shapeName:${name}`);
            const isLimitShape = !this.vip && ~this.limitTableIds.indexOf(tableID);
            window["_view"].dropToScene(ev, isLimitShape);
            if (isLimitShape) {
                // sdk 不启用 vip 符号试用，直接调外壳购买
                if (window.EDCONFIG.VIP.SYMBOL_LIMIT_ENABLE) {
                    this.$openBuyPage("library");
                }
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "library",
                });
                window["_view"].addVipStatePoperList("vipShape");
            }

            this.removeImg();
            this.currentShapeIndex = -1;
            document.onmousemove = null;
            document.onmouseup = null;
            window["_view"].updateRulers();
        };
    }

    getTableData(groupName, tableData) {
        let { id: tableId, tableName } = tableData;
        let tempData = {
            id: tableId,
            title: tableName,
            group: groupName,
            data: [],
        } as RenderLibraryData;
        LangKeys.forEach((langKey) => {
            tempData[langKey] = tableData[`tableName_${langKey}`];
        });
        return new Promise((RS, RJ) => {
            if (!tableName) {
                // 出错中断
                RS([]);
                return;
            }
            let opendb = window.indexedDB.open(groupName);
            opendb.onsuccess = (e) => {
                let db = (e.target as IDBOpenDBRequest).result;
                const tableNames = db.objectStoreNames;
                if (!tableNames.contains(tableName)) {
                    db.close();
                    RS([]);
                    return;
                }
                let transaction = db.transaction(tableName);
                let store = transaction.objectStore(tableName);
                let request = store.openCursor();
                request.onsuccess = (e) => {
                    let cursor = (e.target as IDBRequest).result;
                    if (cursor) {
                        let cursordata = cursor.value;
                        if (cursordata.data) {
                            let tempIMG = cursordata.data.match(/!\[CDATA\[[^\[\]]*?\]\]/g);
                            let obj = {
                                table_index: cursordata.index,
                                name: cursordata.name,
                                url: cursordata.blob && URL.createObjectURL(cursordata.blob),
                                blob: cursordata.blob,
                                shape: cursordata.data,
                                table_id: cursordata.tableID || tableId,
                                tempIMG: tempIMG ? tempIMG : [],
                                next: cursordata.next,
                                hasControl: this.hasControlData(cursordata.data),
                            } as LibraryItem;

                            Object.assign(obj, {
                                isVip: this.checkVipSymbol(obj.shape),
                            });

                            LangKeys.forEach((langKey) => {
                                let k = `${langKey}_name`;
                                obj[k] = cursordata[k];
                            });

                            tempData.data.push(obj);
                        }
                        cursor.continue();
                    } else {
                        if (tempData.data) {
                            tempData.data = this.mapSort(tempData.data);
                        }
                        this.loadShapeImg(tempData.data).then((e) => {
                            RS(tempData.data);
                        });
                    }
                };
                db.close();
            };
            opendb.onerror = (e) => {
                console.log(e);
            };
        });
    }

    mapSort(linkedList) {
        var sortedList = [];
        var map = new Map();
        var currentId = null;

        for (var i = 0; i < linkedList.length; i++) {
            var item = linkedList[i];
            if (item.next === null) {
                currentId = item.table_index;
                sortedList.push(item);
            } else {
                map.set(item.next, i);
            }
        }

        while (sortedList.length < linkedList.length) {
            var previousItem = linkedList[map.get(currentId)];
            if (previousItem) {
                sortedList.unshift(previousItem);
                currentId = previousItem.table_index;
            }
        }

        return sortedList;
    }

    loadShapeImg(obj) {
        // 等待shape里面的图形加载完成
        return new Promise((RS, RJ) => {
            let promiseList = [];
            for (let i = 0; i < obj.length; i++) {
                if (obj[i].tempIMG.length > 0) {
                    let imgList = obj[i].tempIMG;
                    for (let j = 0; j < imgList.length; j++) {
                        promiseList.push(
                            new Promise((res, rej) => {
                                let imgString = imgList[j].slice(8, -2);
                                let head = imgString.substr(0, 30);
                                let img = new Image();
                                if (/data\:image\/.+\;base64\,/.test(head)) {
                                    img.src = imgString;
                                } else {
                                    img.src = `data:image/png;base64,${imgString}`;
                                }
                                img.onload = () => {
                                    res();
                                };
                            })
                        );
                    }
                }
            }
            Promise.all(promiseList).then((e) => {
                RS();
            });
        });
    }

    downloadDBs(arr) {
        return new Promise((rs, rj) => {
            this.worker = new Worker(this.libraryWorkerURL);
            this.worker.postMessage({
                type: "checkAll",
                arr,
                urls: this.urls,
            });
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "download error") {
                    this.worker.terminate();
                    (<any>this).$edMessage.warning(this.$t("createFail"));
                    rj(message);
                }
                if (message.type === "loaded") {
                    this.worker.terminate();
                    rs();
                }
            };
        });
    }

    checkVipSymbol(content: string) {
        let reg = new RegExp('FromLibId V="(\\d*)"', "g");
        let match;
        const list = [];
        while ((match = reg.exec(content))) {
            list.push(match[1]);
        }
        if (list) {
            for (let item of list) {
                if (this.limitTableIds.includes(Number(item))) {
                    return true;
                }
            }
        }
    }

    get limitTableIds() {
        return this.internal ? InternalLimitTableIds : OverseaLimitTableIds;
    }

    hasControlData(data: string) {
        let controlRx = /<Control (.*?)<\/Control>/g;
        let disableRx = /<Disabled (.*?)>/g;
        let controls = data.match(controlRx);
        if (controls && controls.length) {
            for (let i = 0; i < controls.length; i++) {
                let control = controls[i];
                let disables = control.match(disableRx);
                if (disables && disables.length) {
                    for (let k = 0; k < disables.length; k++) {
                        let disable = disables[k];
                        if (disable.indexOf('F="IFV(ISEMPTY(Text.') >= 0) {
                            continue;
                        }
                        return true;
                    }
                }
            }
        }
        return false;
    }
}
